module.exports = __webpack_public_path__ + "static/media/discord.fbf2ef41.png";